function getCookie(name: string): string | undefined {
  const cookies = document.cookie
    .split(";")
    .filter(c => c.startsWith(name + "="));
  if (cookies.length === 0) {
    return undefined;
  }
  return cookies[0].split("=")[1];
}

export default getCookie;
